// ============================================================================
// JARVISTRAVEL - SIGN-IN UNREACHABLE (JAR-2493)
//
// What a screen that needs Clerk shows once useClerkStalled says it hasn't
// loaded. Try again reloads, which fetches Clerk afresh: an installed app has no
// address bar or reload button of its own.
// ============================================================================

import { WifiOff } from 'lucide-react';
import { Button } from '@/app/components/shared';

export const SIGN_IN_UNREACHABLE = 'We can’t reach sign-in right now. Check your connection, then try again.';

export function SignInUnreachable() {
  return (
    <div role="alert" className="flex flex-col items-center gap-3 text-center">
      <WifiOff className="w-6 h-6 text-muted" strokeWidth={1.75} aria-hidden="true" />
      <p className="text-sm text-body">{SIGN_IN_UNREACHABLE}</p>
      {/* A button, not a submit: on the sign-in screen this sits inside the form. */}
      <Button type="button" variant="primary" onClick={() => window.location.reload()}>
        Try again
      </Button>
    </div>
  );
}
